import React from "react";
import {DetailsCard} from "./DetailsCard";
import {UserDetailsUIProvider} from "./UserDetailsUIContext"

export default function UserDetailsPage() {
  return (
    <UserDetailsUIProvider>
      <DetailsCard/>
    </UserDetailsUIProvider>
  );
}
